function downloadFile(blob: Blob | string, fileName: string) {
	// const blob = new Blob([content], { type: mimeType });
	if (navigator.msSaveBlob) {
		// IE 10+
		navigator.msSaveBlob(blob, fileName);
	} else {
		const link = document.createElement("a");
		// Browsers that support HTML5 download attribute
		if (link.download !== undefined) {
			const dataURL = typeof blob === "string" ? blob : URL.createObjectURL(blob);
			link.setAttribute("href", dataURL);
			link.setAttribute("download", fileName);
			link.style.visibility = "hidden";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			if (typeof blob === "string") {
				// To avoid memory leaks, clean dataURL
				URL.revokeObjectURL(dataURL);
			}
		}
	}
}

const readFileAsArrayBuffer: (file: File) => Promise<ArrayBuffer> = file => {
	const temporaryFileReader = new FileReader();

	return new Promise((resolve, reject) => {
		temporaryFileReader.onerror = () => {
			temporaryFileReader.abort();
			reject(new DOMException("Problem parsing input file."));
		};

		temporaryFileReader.onload = () => {
			if (temporaryFileReader.result instanceof ArrayBuffer) {
				resolve(temporaryFileReader.result);
			} else {
				reject(new DOMException("Problem parsing input file, unexcepted type..."));
			}
		};
		temporaryFileReader.readAsArrayBuffer(file);
	});
};

export { downloadFile, readFileAsArrayBuffer };
